module.exports = __webpack_public_path__ + "static/img/Q1.b12eab9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SuperAce/Q1.png
// module id = M8Je
// module chunks = 0